import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Header = ({ setSidebarOpen }) => {
  const { currentUser, logout } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);

  const handleLogout = () => {
    logout();
  };

  const closeDropdown = () => {
    setShowDropdown(false);
  };

  return (
    <header className="app-header">
      <div className="header-container">
        <div className="header-left">
          <button
            className="menu-button"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="menu-icon">☰</span>
            <span className="sr-only">Open sidebar</span>
          </button>
          <h1 className="header-title">NeoChat Admin Dashboard</h1>
        </div>
        
        <div className="header-right">
          {/*<button
                      className="notification-button"
                      onClick={() => alert('Notifications feature coming soon!')}
                    >
                      <span className="notification-icon">🔔</span>
                      <span className="sr-only">View notifications</span>
                    </button>*/}

          {/* Profile dropdown */}
          <div className="profile-dropdown">
            <button 
              className="profile-button"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              <span className="profile-icon">👤</span>
            </button>
            
            {showDropdown && (
              <div className="dropdown-menu">
                <div className="dropdown-header">
                  <p className="user-name">{currentUser?.name || 'User'}</p>
                  <p className="user-email">{currentUser?.email || 'user@example.com'}</p>
                </div>
                <div className="dropdown-items">
                  <Link 
                    to="/profile" 
                    className="dropdown-item"
                    onClick={closeDropdown}
                  >
                    Your Profile
                  </Link>
                  <Link 
                    to="/settings" 
                    className="dropdown-item"
                    onClick={closeDropdown}
                  >
                    Settings
                  </Link>
                  <button className="dropdown-item" onClick={handleLogout}>
                    Sign out
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 